import { Login, Register, ForgotPassword, OTPVerify } from "@/lib/validations";
import {
  LoginResponse,
  RegisterResponse,
  OTPVerifyResponse,
  ForgotPasswordResponse,
  ResendOTPResponse,
} from "@/types";
import LoginButton from "./login-button";

interface AuthWrapperProps {
  onLogin: (values: Login) => Promise<LoginResponse>;
  onRegister: (values: Register) => Promise<RegisterResponse>;
  onVerifyOTP: (values: OTPVerify) => Promise<OTPVerifyResponse>;
  onForgotPassword: (values: ForgotPassword) => Promise<ForgotPasswordResponse>;
  onResendOTP: (values: { email: string }) => Promise<ResendOTPResponse>;
}

export default function AuthWrapper(props: AuthWrapperProps) {
  return <LoginButton {...props} />;
}
